module.exports = __webpack_public_path__ + "img/corporate_history.eb10b790.png";